import React from "react";
import {
  Phone,
  Mail,
  MapPin,
  Clock,
  Facebook,
  Instagram,
  Twitter,
  Linkedin,
  Youtube,
} from "lucide-react";
import logo_white from "../img/logo_white.png";

const Footer = () => {
  const serviceAreas = [
    "Vancouver",
    "Surrey",
    "Delta",
    "Langley",
    "Burnaby",
    "Abbotsford",
    "Chilliwack",
    "Mission",
    "Victoria",
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src={logo_white}
              alt="Blackbros Delivery Company Ltd"
              className="h-16 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-sm">
              Professional moving services across British Columbia.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-base font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <a
                href="tel:7783260735"
                className="flex items-center text-sm hover:text-orange-500 transition-colors"
              >
                <Phone size={16} className="mr-2" />
                (778) 326-0735
              </a>
              <a
                href="mailto:contact@blackbrosdelivery.ca"
                className="flex items-center text-sm hover:text-orange-500 transition-colors"
              >
                <Mail size={16} className="mr-2" />
                contact@blackbrosdelivery.ca
              </a>
              <div className="flex items-start text-sm">
                <Clock size={16} className="mr-2 mt-0.5 flex-shrink-0" />
                <span>Mon–Sun: 8am–8pm</span>
              </div>
            </div>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="text-white text-base font-semibold mb-4">
              Service Areas
            </h4>
            <div className="flex items-start text-sm">
              <MapPin size={16} className="mr-2 mt-0.5 flex-shrink-0" />
              <div className="flex flex-wrap gap-1">
                {serviceAreas.map((area, index) => (
                  <span key={area}>
                    {area}
                    {index < serviceAreas.length - 1 && ", "}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-base font-semibold mb-4">
              Quick Links
            </h4>
            <div className="space-y-2">
              <a
                href="/"
                className="block text-sm hover:text-orange-500 transition-colors"
              >
                Home
              </a>
              <a
                href="/about"
                className="block text-sm hover:text-orange-500 transition-colors"
              >
                About Us
              </a>
              <a
                href="/services"
                className="block text-sm hover:text-orange-500 transition-colors"
              >
                Services
              </a>
              <a
                href="/contact"
                className="block text-sm hover:text-orange-500 transition-colors"
              >
                Get a Quote
              </a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-white text-base font-semibold mb-4">
              Follow Us
            </h4>
            <div className="flex flex-wrap gap-3">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-orange-500 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-orange-500 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-orange-500 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="Twitter"
              >
                <Twitter size={18} />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-orange-500 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-10 h-10 bg-gray-800 hover:bg-orange-500 rounded-full transition-all duration-300 hover:scale-110"
                aria-label="YouTube"
              >
                <Youtube size={18} />
              </a>
            </div>
            <p className="text-xs text-gray-400 mt-4">
              Stay connected with us for updates and moving tips!
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-center text-sm">
              &copy; {new Date().getFullYear()} Blackbros Delivery Company Ltd.
              All rights reserved.
            </p>
            <div className="flex gap-4 text-sm">
              <a href="#" className="hover:text-orange-500 transition-colors">
                Privacy Policy
              </a>
              <span className="text-gray-600">|</span>
              <a href="#" className="hover:text-orange-500 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
